import { AText, Box, Button } from '@alf/uikit';
import { useGeneralRoutes } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { LocalizedLink, useI18n } from '@namespace/i18n';

import styles from './index.module.css';

export const PromotionsEmptyState = ({
  activePromoType,
  promotionTabs,
  withPlayButton = false,
  title = ''
}) => {
  const { isDesktop } = useDeviceStore();
  const { t } = useI18n();

  const { games } = useGeneralRoutes();

  return (
    <Box
      className={styles.wrapper}
      justify="center"
      align="center"
      direction="column"
    >
      <img
        className={styles.placeholderImage}
        src={promotionTabs[activePromoType]?.placeholderImage}
        alt="placeholderImage"
      />
      <AText
        className={styles.placeholderText}
        breed="BU"
        size={isDesktop ? '3xl' : '2xl'}
        color="txt_color_7"
        align="center"
      >
        {title || t(`web.${activePromoType}.placeholder`)}
      </AText>
      {withPlayButton && (
        <Button
          component={LocalizedLink}
          to={games}
          className={styles.buttonPlay}
          isNextButton={true}
          size="xl"
        >
          <AText className={styles.buttonText} size="xl" breed="R">
            {t(`web.${activePromoType}.lobby.buttonplay`)}
          </AText>
        </Button>
      )}
    </Box>
  );
};
